import React from "react";
import { Container, Input } from "../../Styles/Global.Styled";
import MaginfierEyeIcon from "../../Icons/MaginfierEyeIcon";
import { css } from "styled-components";

const searchFormCnt = css`
  border: 1px solid ${({ theme }) => theme.main};
  border-radius: 25px;
  align-items: center;
  padding: 0.5vh;
  height: 3vh;
  background-color: ${({ theme }) => theme.bgColor};
  align-self: center;
`;

const SearchForm = () => {
  return (
    <Container
      $baseStyle={searchFormCnt}
      $mStyle={css`
        border: none;
        background-color: inherit;
      `}
    >
      <Input
        placeholder="Search"
        $baseStyle={css`
          border: none;
        `}
        $mStyle={css`
          display: none;
        `}
      />
      <MaginfierEyeIcon style={{ height: "2.5vh" }} />
    </Container>
  );
};

export default SearchForm;
